// extracted by mini-css-extract-plugin
module.exports = {"item_img":"list_item_img__0FOGM","item":"list_item__TBOD5","more":"list_more__wR5yk","title":"list_title__rDzzd"};